import { useCustomerlyContext } from "./provider";

export const useCustomerly = () => {
  return useCustomerlyContext();
};
